import { render } from "./IconTSV.vue?vue&type=template&id=2eb3bc98"
import script from "./IconTSV.vue?vue&type=script&lang=ts"
export * from "./IconTSV.vue?vue&type=script&lang=ts"
script.render = render

export default script